import authorizedAxios from "../../helpers/authorizedAxios";
import { showToast } from "../../utils/helpers/ShowToast";

export const SET_PRODUCT_CATEGORIES = "SET_PRODUCT_CATEGORIES";
export const SET_MATERIAL_CATEGORIES = "SET_MATERIAL_CATEGORIES";
export const SET_CATEGORIES = "SET_CATEGORIES";
export const SET_CATEGORIES_LOADING = "SET_CATEGORIES_LOADING";
export const SET_CATEGORIES_ERROR = "SET_CATEGORIES_ERROR";

const CATEGORY_ENDPOINTS = {
  product: "/product-categories",
  material: "/material-categories",
};

const setError = (dispatch, error) => {
  dispatch({
    type: SET_CATEGORIES_ERROR,
    error: error?.response?.data?.message || error?.message || "Terjadi kesalahan pada data kategori.",
  });
};

const getEndpoint = (type) => CATEGORY_ENDPOINTS[type] || CATEGORY_ENDPOINTS.product;

const getSetType = (type) => (type === "material" ? SET_MATERIAL_CATEGORIES : SET_PRODUCT_CATEGORIES);

export const fetchCategories = (type = "product", limit = 100, page = 1, search = "") => async (dispatch) => {
  dispatch({ type: SET_CATEGORIES_LOADING, status: true });
  try {
    const isAllCategory = !type || type === "all";
    const response = await authorizedAxios.get(isAllCategory ? "/categories" : getEndpoint(type), {
      params: { limit, page, search },
    });
    dispatch({ type: isAllCategory ? SET_CATEGORIES : getSetType(type), data: response?.data?.data });
    return response?.data?.data;
  } catch (error) {
    setError(dispatch, error);
    return null;
  } finally {
    dispatch({ type: SET_CATEGORIES_LOADING, status: false });
  }
};

export const fetchAllCategories = (limit = 100, page = 1, search = "") =>
  fetchCategories("all", limit, page, search);

export const fetchProductCategories = (limit = 100, page = 1, search = "") =>
  fetchCategories("product", limit, page, search);

export const fetchMaterialCategories = (limit = 100, page = 1, search = "") =>
  fetchCategories("material", limit, page, search);

export const addCategory = (type, data) => async (dispatch) => {
  dispatch({ type: SET_CATEGORIES_LOADING, status: true });
  try {
    await showToast(authorizedAxios.post(getEndpoint(type), data), {
      loading: "Menyimpan kategori...",
      success: "Kategori berhasil ditambahkan!",
      error: (error) => error?.response?.data?.message || "Gagal menyimpan kategori!",
    });
    return true;
  } catch (error) {
    setError(dispatch, error);
    return false;
  } finally {
    dispatch({ type: SET_CATEGORIES_LOADING, status: false });
  }
};

export const updateCategory = (type, id, data) => async (dispatch) => {
  dispatch({ type: SET_CATEGORIES_LOADING, status: true });
  try {
    await showToast(authorizedAxios.put(`${getEndpoint(type)}/${id}`, data), {
      loading: "Memperbarui kategori...",
      success: "Kategori berhasil diperbarui!",
      error: (error) => error?.response?.data?.message || "Gagal memperbarui kategori!",
    });
    return true;
  } catch (error) {
    setError(dispatch, error);
    return false;
  } finally {
    dispatch({ type: SET_CATEGORIES_LOADING, status: false });
  }
};

export const deleteCategory = (type, id) => async (dispatch) => {
  dispatch({ type: SET_CATEGORIES_LOADING, status: true });
  try {
    await showToast(authorizedAxios.delete(`${getEndpoint(type)}/${id}`), {
      loading: "Menghapus kategori...",
      success: "Kategori berhasil dihapus!",
      error: (error) => error?.response?.data?.message || "Gagal menghapus kategori!",
    });
    return true;
  } catch (error) {
    setError(dispatch, error);
    return false;
  } finally {
    dispatch({ type: SET_CATEGORIES_LOADING, status: false });
  }
};
